import { render, staticRenderFns } from "./contact_data_response.vue?vue&type=template&id=12407680&scoped=true&"
import script from "./contact_data_response.vue?vue&type=script&lang=js&"
export * from "./contact_data_response.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12407680",
  null
  
)

export default component.exports